export function MethodologyFooter() {
  return (
    <footer className="border-t border-border bg-bg-page">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-8 py-12 text-[13px] leading-relaxed text-ink-muted">
        <span className="text-xs font-medium uppercase tracking-[0.12em] text-ink-dim">
          Methodology
        </span>
        <p className="max-w-3xl">
          Per-firm figures come from discussions with around 10 firms spanning
          small, mid-tier and large-firm segments. Charge-out rate presets and
          per-case spend reflect 2025–2026 UK rates. The editable role-hour mix
          is calibrated to each current per-case baseline. Time-saving figures
          assume Asset Hound replaces the manual document generation, email and
          reporting workflow firms run today
        </p>
        <p className="max-w-3xl">
          Numbers are illustrative, not contractual. Editable scenarios show the
          rough size of the opportunity; they are not a quote, forecast or
          guarantee
        </p>
      </div>
    </footer>
  );
}
